import { createReducer, on } from '@ngrx/store';

import { INITIAL_TAGS_STATE } from './tags.constants';
import { TagsState } from './tags.model';
import { TagsActions, TagsApiActions } from './tags.actions';

export const tagsReducer = createReducer(
  INITIAL_TAGS_STATE,

  on(
    TagsActions.loadTags,
    (state): TagsState => ({
      ...state,
      loadTagsError: null,
    }),
  ),

  on(
    TagsApiActions.loadTagsSuccess,
    (state, { tags }): TagsState => ({
      ...state,
      tags,
      loadTagsError: null,
    }),
  ),

  on(
    TagsApiActions.loadTagsFailure,
    (state, { error }): TagsState => ({
      ...state,
      tags: [],
      loadTagsError: error,
    }),
  ),

  on(
    TagsActions.createTag,
    (state): TagsState => ({
      ...state,
      creatingTag: true,
      createTagError: null,
      lastCreatedTag: null,
    }),
  ),

  on(
    TagsApiActions.createTagSuccess,
    (state, { tag }): TagsState => ({
      ...state,
      tags: [...state.tags, tag],
      creatingTag: false,
      createTagError: null,
      lastCreatedTag: tag,
    }),
  ),

  on(
    TagsApiActions.createTagFailure,
    (state, { error }): TagsState => ({
      ...state,
      creatingTag: false,
      createTagError: error,
      lastCreatedTag: null,
    }),
  ),
);
